import { Reveal } from "../Reveal";

const chapters = [
  { n: "01", title: "We interrogate your story", body: "Every engagement opens with a deep-dive strategy session. We mine your achievements, quantify impact, and surface the narrative recruiters actually reward." },
  { n: "02", title: "We write for humans and machines", body: "Your resume is engineered to clear ATS filters and then stop a hiring manager mid-scroll. Precise language, ruthless editing, zero filler." },
  { n: "03", title: "We position, not just polish", body: "LinkedIn, cover letters and personal brand aligned into one coherent story — so every touchpoint says the same confident thing." },
  { n: "04", title: "We open doors", body: "Curated job opportunities, referral pathways and interview coaching turn a great document into a great offer." },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="bg-cream py-28 lg:py-40" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-[0.4fr_0.6fr] gap-10 mb-20">
          <span className="overline text-cobalt">The Method</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-navy leading-[1.02]">
            A deliberate process, <span className="italic">not a template.</span>
          </h2>
        </div>

        <div className="space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="grid lg:grid-cols-[0.18fr_0.42fr_0.4fr] gap-6 lg:gap-16 py-12 border-t border-navy/15 items-start group">
                <span className="font-mono-ui text-5xl lg:text-6xl text-navy/25 group-hover:text-cobalt transition-colors">{c.n}</span>
                <h3 className="font-display text-2xl lg:text-3xl font-semibold text-navy">{c.title}</h3>
                <p className="text-slateink text-lg leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
